// extracted by mini-css-extract-plugin
export default {"hero":"hero__3k_5o","wordWrapper":"wordWrapper__1947y","hiddenWord":"hiddenWord__CkEpp","word":"word__2Bn0Y"};